import "./ExcalidrawLogo.scss";

const LogoIcon = () => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="ExcalidrawLogo-icon"
  >
    <rect width="40" height="40" rx="8" fill="currentColor" />
    <text
      x="20"
      y="28"
      textAnchor="middle"
      fontFamily="sans-serif"
      fontWeight="bold"
      fontSize="22"
      fill="white"
    >
      QS
    </text>
  </svg>
);

const LogoText = () => (
  <span
    className="ExcalidrawLogo-text"
    style={{
      fontFamily: "Assistant, sans-serif",
      fontWeight: 700,
      fontSize: "1.2em",
      letterSpacing: "-0.03em",
      whiteSpace: "nowrap",
    }}
  >
    SimpleDraw
  </span>
);

type LogoSize = "xs" | "small" | "normal" | "large" | "custom" | "mobile";

interface LogoProps {
  size?: LogoSize;
  withText?: boolean;
  style?: React.CSSProperties;
  /**
   * If true, the logo will not be wrapped in a Link component.
   * The link prop will be ignored as well.
   * It will merely be a plain div.
   */
  isNotLink?: boolean;
}

export const ExcalidrawLogo = ({
  style,
  size = "small",
  withText,
}: LogoProps) => {
  return (
    <div className={`ExcalidrawLogo is-${size}`} style={style}>
      <LogoIcon />
      {withText && <LogoText />}
    </div>
  );
};
